// tslint:disable:max-line-length

import {strEnum} from "../../types";
import {ILAUserClaims} from "../liveapps/liveapps-model";

export interface IUserCap {
    cc: string;
    icmock: string;
    icwi: string;
    icbw: string;
    icnode: string;
}

export interface ITCIUserCap {
    username: string;
    region: string;
    cap: IUserCap;
}

export interface ITCIUserLogout {
    status: boolean;
    message: string;
}

/**
 * interface ITCIUserInfo
 */
export interface ITCIUserInfo {
    uname: string;
    userId: string;
    ve: any;
    aud: string[];
    exp: number;
    jti: string;
    iat: number;
    nbf: number;
    sub: string;
    fn: string;
    ln: string;
    ses: string;
    regn: string;
    auth: string;
    ll: number;
    gacct: string[];
    accts: string[];
    admn: boolean;
    eula: boolean;
    sbsc: string;
    guid: string;
    gsbc: string;
    sexp: { [key: string]: number }; // {TCI: 1552821068},
    cc: string;
    icnode: string;
    admnX: boolean;
    eulX: boolean;
    reg: boolean;
    dsbl: boolean;
    icmock: string;
    icwi: string;
    icbw: string;
    JWT: string;
    orgId: number; // Scribe OrgId, value present when Scribe Service is available
    maskedID: string;
    rolX: string[];
    email?: string;
    st?: string; // Integration Subscription Type
    stat?: number; // Integration Status
    hid?: string;
    hacct?: string;
    gsbcSha256?: string;
    clusterId?: string;
    esIndex?: string;   // ElasticSearch index name
    bpm?: ILAUserClaims; // value present when LA service is available
    /** True if UCS should be enabled for this user */
    ucs?: boolean;
}

export interface ITCIUserProfile {
    userName: string;
    firstName: string;
    lastName: string;
}

export const USER_ROLES = strEnum([
    "ADM",
    "USR",
    "RO"
]);
export const USER_SUBSCRIPTION_TRIAL = "TRIAL";
